var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "location py-4 border-b border-grey-light" }, [
    _c("div", { staticClass: "row mx-0 items-center" }, [
      _c(
        "div",
        { staticClass: "col px-0 xs:pr-2 w-full xxs:w-2/5 xs:w-1/3 sm:w-2/5" },
        [
          _c("h3", [
            _c(
              "a",
              {
                staticClass: "location__name",
                attrs: { href: _vm.location.link }
              },
              [_vm._v(_vm._s(_vm.location.title.rendered))]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "col w-full px-0 mb-3 xxs:mb-0 sm:pl-8 xxs:w-3/5 xs:w-2/3 sm:w-3/5"
        },
        [
          _c("div", { staticClass: "row justify-between mx-0" }, [
            _c("ul", { staticClass: "list-reset w-full flex" }, [
              _c("li", { staticClass: "col px-1 xxs:w-2/5 text-center" }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "location__details flex items-center justify-start relative uppercase text-black hover:text-red focus:text-red text-xs",
                    attrs: { href: _vm.location.link }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "w-4 h-4 location__icon" },
                      [_c("details-icon")],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "pl-2" }, [_vm._v("Details")])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "col px-1 xxs:w/3-5 text-center" }, [
                _c(
                  "a",
                  {
                    staticClass: "location__distance",
                    attrs: { target: "_blank", href: _vm.mapsUrl }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "w-4 h-4 location__icon" },
                      [_c("navigation-icon")],
                      1
                    ),
                    _vm._v(" "),
                    _vm.location.matrix
                      ? _c("div", { staticClass: "pl-2 lowercase" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.distance) +
                              "\n              "
                          )
                        ])
                      : _c("div", { staticClass: "pl-2 uppercase" }, [
                          _vm._v("Directions")
                        ])
                  ]
                )
              ])
            ])
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col location__address-hours pt-2" },
        [
          _c(
            "a",
            {
              staticClass:
                "location__address text-black hover:text-yellow focus:text-yellow",
              attrs: { href: _vm.mapsUrl }
            },
            [_vm._v(_vm._s(_vm.renderedAddress))]
          ),
          _vm._v(" "),
          !_vm.location.meta.temporarily_closed
            ? _c("hours", {
                attrs: {
                  location: _vm.location,
                  hours: _vm.hours,
                  closed: _vm.closed
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.location.meta.temporarily_closed
            ? _c("closed-message", { attrs: { title: "Temporarily Closed" } })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-441df0ee", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /Users/kristinberlehner/sites/mardens/wp-content/themes/mardens/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-441df0ee","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!/Users/kristinberlehner/sites/mardens/wp-content/themes/mardens/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/Location.vue
// module id = 412
// module chunks = 0